var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHegrenade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.98 19.683",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97.587 -164.03)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2221 0 0 .2221 93.682 157.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58 37.881c0 0.484-4.328 1.07-9.618 1.301-8.009 0.35-9.852 0.74-11.014 2.329-1.806 2.471-1.304 3.796 1.706 4.504 2.273 0.534 2.471 1.134 3.146 9.528 0.397 4.926 0.545 9.463 0.33 10.082-0.215 0.618-2.419 1.428-4.897 1.8-9.454 1.417-14.653 7.828-14.653 18.066 0 11.72 3.942 18.866 12.798 23.198 4.647 2.274 6.856 2.711 13.702 2.711 13.721 0 21.708-5.199 25.586-16.654l1.623-4.795 0.689 9.12c0.482 6.392 0.34 9.54-0.477 10.525-0.686 0.825-0.754 1.404-0.166 1.404 2.944 0 3.325-2.896 2.451-18.654l-0.879-15.846-7.62-17c-10.321-23.026-10.045-22.483-11.457-22.492-0.687-4e-3 -1.25 0.388-1.25 0.873m-1.817 25.241c0.301 3.067 0.621 3.3 6.279 4.58 6.431 1.454 10.019 4.057 12.126 8.798 0.734 1.65 1.35 2.325 1.369 1.5s-2.101-5.1-4.711-9.5l-4.746-8-5.317-0.305-5.318-0.304 0.318 3.231",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHegrenade);
export default __webpack_public_path__ + "static/media/hegrenade.b167dbc92faeb4fba2ab4b9ba01d19b5.svg";
export { ForwardRef as ReactComponent };